<ng-container *ngIf="!isLoading">
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="form-row">
        <div class="form-group col-12">
          <label [class.font-weight-bold]="form.get('name')?.dirty" for="name">
            {{ "headers.criticality.criticality" | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            [ngClass]="{
              'is-invalid': isSubmitted && form.get('name')?.invalid
            }"
            class="form-control form-control-sm"
            formControlName="name"
            id="name"
            type="text"
          />
          <div
            class="text-danger"
            *ngIf="showValidationError && form.get('name')?.invalid"
          >
            {{ "messages.required" | translate }}
          </div>
        </div>
        <div class="form-group col-12">
          <label
            [class.font-weight-bold]="form.get('threshold')?.dirty"
            for="threshold"
          >
            {{
              "headers.risk_parameters.criticality_levels.threshold" | translate
            }}
            <span class="text-danger">*</span>
          </label>
          <input
            [ngClass]="{
              'is-invalid':
                showValidationError && form.get('threshold')?.invalid
            }"
            class="form-control form-control-sm"
            formControlName="threshold"
            id="threshold"
            type="number"
          />
          <div
            class="text-danger"
            *ngIf="
              showValidationError && form.get('threshold')?.errors?.required
            "
          >
            {{ "messages.required" | translate }}
          </div>
          <div
            class="text-danger"
            *ngIf="showValidationError && form.get('threshold')?.errors?.min"
          >
            {{ "messages.positive" | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="form-group">
      <div class="col-12 d-flex justify-content-between">
        <button (click)="bsModalRef.hide()" class="btn btn-sm btn-light mr-2">
          <i class="la la-ban"></i>
          {{ "navigations.cancel" | translate }}
        </button>
        <button
          (click)="save()"
          [disabled]="isSubmitted"
          class="btn btn-sm btn-success"
        >
          <i *ngIf="!isSubmitted" class="la la-save"></i>
          <i *ngIf="isSubmitted" class="la la-spinner la-spin"></i>
          {{ "navigations.save" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
